import { createSelector } from '@base-ui/utils/store';
import { eventTimelinePremiumViewSelectors } from "./eventTimelinePremiumViewSelectors.mjs";
export const timelineOccurrencePlaceholderSelectors = {
  placeholderInResource: createSelector((state, resourceId) => {
    if (state.occurrencePlaceholder === null || state.occurrencePlaceholder.surfaceType !== 'timeline' || state.occurrencePlaceholder.isHidden || state.occurrencePlaceholder.resourceId !== resourceId) {
      return null;
    }
    const viewConfig = eventTimelinePremiumViewSelectors.config(state);
    if (state.adapter.isBefore(state.occurrencePlaceholder.end, viewConfig.start) || state.adapter.isAfter(state.occurrencePlaceholder.start, viewConfig.end)) {
      return null;
    }
    return state.occurrencePlaceholder;
  }),
  isCreatingInResource: createSelector((state, resourceId) => {
    const placeholder = state.occurrencePlaceholder;
    if (placeholder === null || placeholder.surfaceType !== 'timeline' || placeholder.type !== 'creation' || placeholder.resourceId !== resourceId) {
      return false;
    }
    return true;
  })
};